import React from 'react';

interface LabeledValueProps {
  label?: string;
  value?: string | React.ReactNode;
  customStyles?: string;
}
export const LabeledValue: React.FC<LabeledValueProps> = ({ label, value, customStyles = '' }) => {
  return (
    <>
      {label ? (
        <p className={`p3 -medium m-0 py-0 leading-normal ${customStyles}`}>
          {label}: <span className='p3 -book m-0 py-0 leading-normal'> {value || ''}</span>
        </p>
      ) : (
        <p className={`p3 -book m-0 py-0 leading-normal ${customStyles}`}>{value || ''}</p>
      )}
    </>
  )
}

export default LabeledValue;